import React from 'react';
import { Dialog } from '@material-ui/core';
import { ClosableDialogTitle } from 'components/ClosableDialog/ClosableDialogTitle';
import { ClosableDialogContent } from 'components/ClosableDialog/ClosableDialogContent';
import ContactsListTable from './ListTable';
import { ContactListItemAction } from '../../Types';

interface ContactsListModalProps {
  onClose: any,
  title: string,
  stNumber: string,
  btNumber: string,
  contactLevel?: 'ST' | 'BT' | 'All',
  customActions?: ContactListItemAction[],
}

export default function ContactsListModal(props:ContactsListModalProps) {
  const {
    stNumber, btNumber, contactLevel, customActions, title,
  } = props;

  return (
    <Dialog
      onClose={() => props.onClose?.()}
      aria-labelledby="customized-dialog-title"
      open
      fullWidth
      maxWidth={false}
      scroll="paper"
    >
      <ClosableDialogTitle onClose={() => props.onClose?.()}>
        {title}
      </ClosableDialogTitle>

      <ClosableDialogContent dividers style={{ padding: 0 }}>
        <ContactsListTable
          stNumber={stNumber}
          btNumber={btNumber}
          contactLevel={contactLevel}
          customActions={customActions}
        />
      </ClosableDialogContent>
    </Dialog>
  );
}
